import controller from './alerts-actions-content.controller';

const template = require('./alerts-actions-content.html');

export default {
    bindings: {
        rule: '<',
        onRemove: '&',
        onCancel: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/alerts-actions-content.component.js